// humanFactorsEngineeringData.js

const humanFactorsEngineeringData = [
    {
      section: "Mathematics & Natural Sciences",
      subtotal: "30",
      courses: [
        { id: "MATH32", code: "MATH 32", title: "Calculus I", credit: 4 },
        { id: "MATH34", code: "MATH 34", title: "Calculus II", credit: 4 },
        { id: "PHY11", code: "PHY 11", title: "Gen. Physics I w/ lab", credit: 5 },
        { id: "MNS_Elec_a1", code: "Math or Natural Sci. Elec. (a)", title: "", credit: "3-5" },
        { id: "MNS_Elec_a2", code: "Math or Natural Sci. Elec. (a)", title: "", credit: "3-5" },
        { id: "MNS_Elec_a3", code: "Math or Natural Sci. Elec. (a)", title: "", credit: "3-5" },
        { id: "MNS_Elec_a4", code: "Math or Natural Sci. Elec. (a)", title: "", credit: "3-4" },
        { id: "ENP164", code: "ENP 164", title: "App. Behav. Stats.", credit: 3 },
      ],
    },
    {
      section: "Psychology",
      subtotal: "19",
      courses: [
        { id: "PSY1", code: "PSY 1", title: "Introduction to Psychology", credit: 3 },
        { id: "ENP53", code: "ENP 53", title: "Engineering Psychology", credit: 3 },
        { id: "ENP130", code: "ENP 130", title: "Adv. Eng. Psychology", credit: 3 },
        { id: "PSY_Elec_b1", code: "PSY Elective (b)", title: "", credit: "3-5" },
        { id: "PSY_Elec_b2", code: "PSY Elective (b)", title: "", credit: "3-5" },
      ],
    },
    {
      section: "HASS",
      subtotal: "24",
      courses: [
        { id: "ENG1", code: "ENG 1", title: "Expos. Writing or ENG 3", credit: 3 },
        { id: "EM52", code: "EM 52", title: "Tech. & Managerial Com.", credit: 3 },
        { id: "Humanities_Elec_c", code: "Humanities Elective (c)", title: "", credit: "≥3" },
      ],
    },
    {
      section: "Engineering Fundamentals",
      subtotal: "7",
      courses: [
        { id: "EN1", code: "EN 1", title: "Applications in Eng.", credit: 3 },
        { id: "ES2_CS11", code: "ES 2 or CS 11", title: "Intro. Comp. in Eng. or Intro. Comp. Sci.", credit: 4 },
      ],
    },
    {
      section: "Human Factors Engineering",
      subtotal: "23",
      courses: [
        { id: "ENP64", code: "ENP 64", title: "Methods in HFE", credit: 3 },
        { id: "ENP161", code: "ENP 161", title: "HFE Product Design", credit: 3 },
        { id: "ENP166_CS171", code: "ENP 166 or CS 171", title: "Comp. Interface Dsn. or Hu. Comp. Int.", credit: 3 },
        { id: "Senior_Capstone_e", code: "Senior Capstone (e)", title: "", credit: 3 },
        { id: "HFE_Elec_f1", code: "HFE Elective (f)", title: "", credit: 3 },
        { id: "HFE_Elec_f2", code: "HFE Elective (f)", title: "", credit: 3 },
        { id: "CS_HFE_Elec_g", code: "CS or HFE Elective (g)", title: "", credit: "3-5" },
      ],
    },
    {
      section: "Engineering",
      subtotal: "15",
      courses: [
        { id: "ME10", code: "ME 10", title: "Mat. & Manufact.", credit: 4 },
        { id: "ME20_ES5", code: "ME 20 or ES 5", title: "Mechanics I or Statics & Dynamics", credit: 3 },
        { id: "ME30", code: "ME 30", title: "Electronics & Controls I", credit: 4 },
        { id: "ME40", code: "ME 40", title: "Engineering Design I", credit: 4 },
      ],
    },
    {
      section: "Domain Focus",
      subtotal: "12",
      courses: [
        { id: "Domain_Elec_h1", code: "Domain Elective (h)", title: "", credit: "3-5" },
        { id: "Domain_Elec_h2", code: "Domain Elective (h)", title: "", credit: "3-5" },
        { id: "Domain_Elec_h3", code: "Domain Elective (h)", title: "", credit: "3-5" },
        { id: "Domain_Elec_h4", code: "Domain Elective (h)", title: "", credit: "3-5" },
      ],
    },
    {
      section: "Unrestricted Electives",
      subtotal: "",
      courses: [
        { id: "Unrestricted", code: "Unrestricted Electives", title: "≥120 SHU are required for the degree. List additional courses as needed.", credit: "" },
      ],
    },
  ];
  
  export default humanFactorsEngineeringData;
  